module.exports = __webpack_public_path__ + "img/locationPin.8adfdf24.svg";